// src/main.jsx
import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import ReactDOM from "react-dom/client";
import "../styles.css";
import App from "./App";

// Global error handler — shows error on screen if React crashes
window.addEventListener('error', (e) => {
  console.error('Global error:', e.error);
  const root = document.getElementById("root");
  if (root && !root.innerHTML.trim()) {
    root.innerHTML = `
      <div style="padding:2rem;text-align:center;font-family:sans-serif;">
        <h2 style="color:#ef4444;">Произошла ошибка</h2>
        <p style="color:#6b7280;">${e.error?.message || 'Неизвестная ошибка'}</p>
        <button onclick="location.reload()" style="padding:0.75rem 1.5rem;background:#1a1a2e;color:white;border:none;border-radius:8px;cursor:pointer;margin-top:1rem;">Перезагрузить</button>
      </div>`;
  }
});

window.addEventListener('unhandledrejection', (e) => {
  console.error('Unhandled promise rejection:', e.reason);
});

try {
  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
} catch (err) {
  console.error('Failed to mount React:', err);
  const root = document.getElementById("root");
  root.innerHTML = `
    <div style="padding:2rem;text-align:center;font-family:sans-serif;">
      <h2 style="color:#ef4444;">Ошибка монтирования приложения</h2>
      <p style="color:#6b7280;font-family:monospace;font-size:0.875rem;">${err.message}</p>
      <button onclick="location.reload()" style="padding:0.75rem 1.5rem;background:#1a1a2e;color:white;border:none;border-radius:8px;cursor:pointer;margin-top:1rem;">Перезагрузить</button>
    </div>`;
}
